import { connect } from 'react-redux';
import USInvoicingComponent from '../../components/finance/USInvoicing/Index';

const mapStateToProps = state => {
  return {
    token: state.user.token || '',
    user: state.user || {},
    users: state.users || null,
    isSearching: state.usInvoicing.isSearching,
    ordersToInvoice: state.usInvoicing.ordersToInvoice,
    generatedUSInvoiceLink: state.usInvoicing.generatedUSInvoiceLink,
    usInvoiceHistoricalData: state.usInvoicing.usInvoiceHistoricalData,
    configs: state.configs,
  };
};

const USInvoicing = connect(mapStateToProps)(USInvoicingComponent);

export default USInvoicing;